import { IHttpApi } from '@cian/http-api';

import {
  fetchChangeOffersOrder,
  IChangeOffersOrderRequest,
  IChangeOffersOrderResponse200,
  TChangeOffersOrderResponse,
} from '../../repositories/offers-comparison/v1/change-offers-order';
import { ResponseError } from '../../utils/errors/ResponseError';
import { IErrorResponseSchema } from '../../repositories/offers-comparison/entities/schemas/ErrorResponseSchema';

interface IChangeOffersOrderRequestParams {
  httpApi: IHttpApi;
  parameters: IChangeOffersOrderRequest;
}

type TChangeOffersOrderServiceResponse = IChangeOffersOrderResponse200;

export const fetchChangeOffersOrderService = async (
  { httpApi, parameters }: IChangeOffersOrderRequestParams,
  retries?: number,
): Promise<TChangeOffersOrderServiceResponse> => {
  try {
    const response: TChangeOffersOrderResponse = await fetchChangeOffersOrder({ httpApi, parameters });

    if (![200, 204].includes(response.statusCode)) {
      throw new ResponseError({
        domain: 'src/shared/services/compare#fetchChangeOffersOrderService',
        message: (response.response as IErrorResponseSchema).message || '',
      });
    }

    return response as IChangeOffersOrderResponse200;
  } catch (err) {
    if (retries && retries > 1) {
      const response = await fetchChangeOffersOrderService({ httpApi, parameters }, retries - 1);

      return response;
    } else {
      throw err;
    }
  }
};
